module.exports = __webpack_public_path__ + "img/18.ed6a527d.svg";